import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import RecentEpisode from '../components/RecentEpisode';
import { Episode } from '../types/types';
import { EpisodeService } from '../services/EpisodeService';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  const [recentEpisode, setRecentEpisode] = useState<Episode | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRecentEpisode = async () => {
      try {
        setLoading(true);
        const episode = await EpisodeService.getRecentEpisode();
        setRecentEpisode(episode);
      } catch (err) {
        console.error('Error fetching recent episode:', err);
        setError('Failed to load recent episode');
      } finally {
        setLoading(false);
      }
    };

    fetchRecentEpisode();
  }, []);

  // Generate JSON-LD schema for the podcast
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "PodcastSeries",
    "name": "Basketball Culture Podcast",
    "description": "A podcast about basketball culture, featuring discussions about the NBA, European basketball, and streetball.",
    "url": "https://basketballculture.tv",
    "author": {
      "@type": "Person",
      "name": "Basketball Culture Podcast"
    }
  };

  if (recentEpisode) {
    Object.assign(jsonLd, {
      "episode": [{
        "@type": "PodcastEpisode",
        "name": recentEpisode.title,
        "datePublished": recentEpisode.date,
        "timeRequired": recentEpisode.duration,
        "url": `https://www.youtube.com/watch?v=${recentEpisode.videoId}`
      }]
    });
  }

  return (
    <div className="home">
      <Helmet>
        <title>Basketball Culture Podcast - Home</title>
        <meta name="description" content="Welcome to Basketball Culture Podcast - Exploring the intersection of basketball and culture." />
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>

      <Hero />
      
      {loading ? (
        <div className="loading">Loading recent episode...</div>
      ) : error ? (
        <div className="error">{error}</div>
      ) : recentEpisode ? (
        <RecentEpisode episode={recentEpisode} />
      ) : (
        <div className="no-episode">No recent episode available</div>
      )}
    </div>
  );
};

export default Home; 